// Landing Page API Module
import { getData, postData, putData, deleteData } from '../plugins/ApiCalls'

/** Create a landing page (FormData with logo file) */
export function createPage(data) {
  return postData('landing-pages', data)
}

/** Get a single landing page by refId */
export function getPage(refId) {
  return getData('landing-pages/' + refId)
}

/** Get landing page status for polling */
export function getPageStatus(refId) {
  return getData('landing-pages/' + refId + '/status')
}

/** List landing pages with optional params */
export function getPages(params) {
  if (params) {
    return getData('landing-pages?listParams=' + encodeURIComponent(JSON.stringify(params)))
  }
  return getData('landing-pages')
}

/** Update HTML content of existing page */
export function updatePageHtml(refId, html) {
  return putData('landing-pages/' + refId + '/html', { html })
}

/** Regenerate page with optional overrides */
export function regeneratePage(refId, overrides = {}) {
  return postData('landing-pages/' + refId + '/regenerate', overrides)
}

/** Delete a landing page */
export function deletePage(refId) {
  return deleteData('landing-pages/' + refId)
}

/** Bulk delete multiple landing pages */
export function bulkDeletePages(refIds) {
  return postData('landing-pages/bulk-delete', { ref_ids: refIds })
}

/** Get download URL for a page */
export function downloadPage(refId) {
  return getData('landing-pages/' + refId + '/download')
}

/** Get user limitations for creating landing pages */
export function getLimitations() {
  return getData('landing-pages/limitations')
}